export const PRIMARY_PRODUCT_UPDATE_TAGS = ["new", "improved"];
export const DEFAULT_PRODUCT_UPDATE_TAGS = ["new", "improved", "fix"];

export function normalizeProductUpdateTag(value) {
  if (!value) return "";
  return String(value).trim().toLowerCase().replace(/\s+/g, " ");
}

export function parseProductUpdateTags(rawValue) {
  if (!rawValue) return [];

  return Array.from(
    new Set(
      String(rawValue)
        .split(",")
        .map((value) => normalizeProductUpdateTag(value))
        .filter(Boolean),
    ),
  );
}

export function getProductUpdateTagLabel(tag) {
  const normalizedTag = normalizeProductUpdateTag(tag);
  if (!normalizedTag) return "";

  return normalizedTag
    .split(" ")
    .map((value) => value.charAt(0).toUpperCase() + value.slice(1))
    .join(" ");
}

export function getProductUpdateTagBadgeClass(tag) {
  const normalizedTag = normalizeProductUpdateTag(tag);

  if (normalizedTag === "new") {
    return "bg-emerald-50 text-emerald-700 ring-emerald-200";
  }

  if (normalizedTag === "improved") {
    return "bg-sky-50 text-sky-700 ring-sky-200";
  }

  if (normalizedTag === "fix") {
    return "bg-amber-50 text-amber-700 ring-amber-200";
  }

  return "bg-neutral-100 text-neutral-700 ring-neutral-200";
}

export function formatProductUpdateDate(value) {
  if (!value) return "—";

  const parsedDate = new Date(value);
  if (Number.isNaN(parsedDate.getTime())) {
    return String(value);
  }

  return parsedDate.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}

export function formatProductUpdateDateTime(value) {
  if (!value) return "—";

  const parsedDate = new Date(value);
  if (Number.isNaN(parsedDate.getTime())) {
    return String(value);
  }

  return parsedDate.toLocaleString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function toDateTimeLocalValue(value) {
  if (!value) return "";

  const parsedDate = new Date(value);
  if (Number.isNaN(parsedDate.getTime())) {
    return "";
  }

  const year = parsedDate.getFullYear();
  const month = String(parsedDate.getMonth() + 1).padStart(2, "0");
  const day = String(parsedDate.getDate()).padStart(2, "0");
  const hours = String(parsedDate.getHours()).padStart(2, "0");
  const minutes = String(parsedDate.getMinutes()).padStart(2, "0");

  return `${year}-${month}-${day}T${hours}:${minutes}`;
}

export function buildProductUpdateTagList({ tags = [], isNew = false, isImproved = false } = {}) {
  const normalizedTags = tags.map((tag) => normalizeProductUpdateTag(tag)).filter(Boolean);

  if (isNew) {
    normalizedTags.push("new");
  }

  if (isImproved) {
    normalizedTags.push("improved");
  }

  return Array.from(new Set(normalizedTags));
}
